




















































import {Component, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'

@Component
export default class DappDetailedTablesHeader extends MixinScreenSize {
  @Prop({type: Boolean, required: true}) existsOnlyOneTable!: boolean
  @Prop({type: Boolean, required: true}) isSelected!: boolean
  @Prop({type: String, required: true}) table!: string

  handleClick() {
    this.$emit('selected-table', this.table)
  }
}
